module.exports = __webpack_public_path__ + "img/google-play-badge_en.db9b21a1.png";